"use client";

import { useEffect } from "react";

interface SessionExpiredModalProps {
  open: boolean;
  onConfirm: () => void;
}

export default function SessionExpiredModal({ open, onConfirm }: SessionExpiredModalProps) {
  // ESC 키로 닫기 방지
  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* 배경 오버레이 */}
      <div className="absolute inset-0 bg-black/50" />
      
      {/* 모달 내용 */}
      <div className="relative bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
        <div className="flex flex-col items-center gap-4">
          {/* 아이콘 */}
          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
            <svg className="w-6 h-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>

          {/* 메시지 */}
          <div className="text-center">
            <h3 className="text-lg font-bold text-gray-900 mb-2">
              세션이 종료되었습니다
            </h3>
            <p className="text-sm text-gray-600">
              다른 곳에서 로그인되어 현재 세션이 종료되었습니다.
              <br />
              다시 로그인해주세요.
            </p>
          </div>

          {/* 확인 버튼 */}
          <button
            onClick={onConfirm}
            className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}







